<template>
  <div v-if="tariff_info" class="tariff_info">
    <div class="tariff_info__left">
      <div class="content">
        <div class="row">
          <div class="col-md-6">
            <fg-input v-model="tariff_info.name" type="text" :label="translate('tariffication.tariff_name')"
                      :placeholder="translate('tariffication.tariff_name')"
                      :readonly="!$store.getters.getPermissions.permissionGod === true" />
          </div>
          <div class="col-md-3">
            <div class="filter checkbox">
              <div class="info">
                {{ translate('tariffication.tariff_cost') }}
                {{ tariff_info.nds ? translate('tariffication.with_nds') : translate('tariffication.without_nds') }}
              </div>
              <label class="switch no-user-access" @click.prevent="tariff_info.nds = !tariff_info.nds">
                <input type="checkbox" v-model="tariff_info.nds">
                <span class="slider round"></span>
              </label>
            </div>
          </div>

          <div class="col-md-3">
            <div class="filter checkbox">
              <div class="info">
                {{ translate('tariffication.active') }}
              </div>
              <label class="switch" @click.prevent="tariff_info.active = !tariff_info.active"
                     :class="{ 'no-user-access': tariff_info.active_devices.length >= 1 }">
                <input type="checkbox" v-model="tariff_info.active">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <router-link :to="'/client/' + tariff_info.client_id" class="link">
              <fg-input v-model="tariff_info.client_name" type="text" :label="translate('tariffication.client_name')"
                        :readonly="true" />
            </router-link>
          </div>

          <div class="col-md-2">
            <fg-input v-model="tariff_info.cost" type="text"
                      :label="translate('tariffication.tariff_cost') + ' (' + tariff_info.cost_currency + ')'"
                      :placeholder="translate('tariffication.tariff_cost')" :readonly="true" />
          </div>

          <div class="col-md-2">
            <label> {{ translate('tariffication.simcard_count') }} </label>
            <tree-select
                :options="simcard_counts"
                :multiple="false"
                v-model="tariff_info.simcard_count"
                :placeholder="translate('tariffication.simcard_count')"
                :clearable="false"
                :disabled="true"
            />
          </div>

          <div class="col-md-2">
            <fg-input v-model="tariff_info.period" type="text" :label="translate('tariffication.tariff_period')"
                      :readonly="true" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <fg-input v-model="tariff_info.installation_fee" type="text" :label="translate('tariffication.installation_fee')"
                      :readonly="true" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <WrapDatePicker
                v-model="tariff_info.date_start"
                type="date"
                :range="false"
                value_type="YYYY-MM-DD"
                :confirm="false"
                :clearable="false"
                :disabled_date="['- 12 months', '+ 1 month']"
                :label="translate('tariffication.date_start')"
                :placeholder="translate('tariffication.date_start')"
            />
          </div>

          <div class="col-md-3">
            <WrapDatePicker
                v-model="tariff_info.date_end"
                type="date"
                :range="false"
                value_type="YYYY-MM-DD"
                :confirm="false"
                :clearable="true"
                :disabled_date="['- 3 month', '+ 3 month']"
                :label="translate('tariffication.date_end')"
                :placeholder="translate('tariffication.date_end')"
            />
          </div>

          <div class="col-md-6">
            <fg-input v-model="tariff_info.create_user_name" type="text"
                      :label="translate('tariffication.who_created')" :readonly="true" />
          </div>
        </div>

        <div class="row" v-if="Object.keys(tariff_info.contract_info).length > 0">

          <div class="col-md-3">
            <fg-input
                v-model="tariff_info.contract_info.contract_name"
                type="text"
                :label="translate('tariffication.contract_name')"
                :placeholder="translate('tariffication.contract_name')"
                :readonly="true"
            />
          </div>

          <div class="col-md-3">
            <fg-input
                v-model="tariff_info.contract_info.order_prefix"
                type="text"
                :label="translate('tariffication.order_prefix')"
                :placeholder="translate('tariffication.order_prefix')"
                :readonly="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{ translate("tariffication.tariff_descr") }}</label>
              <textarea v-model="tariff_info.descr" rows="3" class="form-control border-input"
                        :placeholder="translate('tariffication.tariff_descr')" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label> {{ translate('tariffication.tariff_billing') }} </label>
            <tree-select :options="billing_type_list" :multiple="false" v-model="tariff_info.billing_type"
                         :placeholder="translate('tariffication.tariff_billing')" :clearable="false" />
          </div>

          <div class="col-md-4">
            <label> {{ translate("tariffication.rate_day") }} </label>
            <tree-select :options="rate_day_list" :multiple="false" v-model="tariff_info.rate_day"
                         :placeholder="translate('tariffication.rate_day')" :clearable="false" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label> {{ translate('tariffication.autoblock_untariffied_devices') }} </label>
            <tree-select :options="autoblock_untariffied_devices_list" :multiple="false" v-model="tariff_info.autoblock_untariffied_devices"
                         :placeholder="translate('tariffication.autoblock_untariffied_devices')" :clearable="false" />
          </div>

          <div class="col-md-4">
            <div class="filter checkbox">
              <div class="info">
                {{ translate('tariffication.auto_block') }}
              </div>
              <label class="switch" @click.prevent="tariff_info.auto_block = !tariff_info.auto_block">
                <input type="checkbox" v-model="tariff_info.auto_block">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="text-center">
          <span v-if="has_changes" class="btn btn-success btn-fill btn-wd marginButton" @click.prevent="edit_tariff">
            {{ translate("save") }}
          </span>
        </div>

      </div>

      <div class="device_list response_table">
        <div class="header">
          <label>
            {{ `${translate("tariff.device_list")} (${tariff_info.active_devices.length})` }}
          </label>
          <div class="links">
            <span
                v-if="tariff_info.active_devices?.length > 0"
                class="mdi mdi-content-copy btn btn-primary btn-fill"
                @click.prevent="copy_fid()"
            >
              Copy FID
            </span>
            <router-link :to="'/tariffication/tariffed_devices?&tariff_ids=' + tariff_info.id">
              Посмотреть все
            </router-link>
          </div>
        </div>

        <table v-if="tariff_info.active_devices.length > 0">
          <thead>
          <tr>
            <th scope="col" class="w60">
            </th>
            <th
                class="pointer status"
                @click="change_filter('status')"
                :class="{ selected: filter_type === 'status' }"
                scope="col"
            >
              {{ translate('tariffication.device_status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('order')"
                :class="{ selected: filter_type === 'order' }"
                scope="col"
            >
              {{ translate('tariffication.order') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('service_id')"
                :class="{ selected: filter_type === 'service_id' }"
                scope="col"
            >
              {{ translate('tariffication.service') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('fid')"
                :class="{ selected: filter_type === 'fid' }"
                scope="col"
            >
              {{ translate('tariffication.device_fid') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('device_name')"
                :class="{ selected: filter_type === 'device_name' }"
                scope="col"
            >
              {{ translate('tariffication.device_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('comment')"
                :class="{ selected: filter_type === 'comment' }"
                scope="col"
            >
              {{ translate('tariffication.comment') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('date_start')"
                :class="{ selected: filter_type === 'date_start' }"
                scope="col"
            >
              {{ translate('tariffication.date_start') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
          </thead>
          <tbody>
              <router-link
                v-for="(device, index) in device_list" :key="index"
                :to="'/tariffed_device/' + device.id"
                class="tariffed_device"
              >
                <tr>
                  <td :data-label="translate('device.name')" class="w60">
                    {{ index + 1 }}
                  </td>

                  <td :data-label="translate('status')" class="status" >
                    <sis-icon-status :status="device.status" style="width: 20px"/>
                  </td>

                  <td :data-label="translate('tariffication.order')">
                    <span>{{device.order }}</span>
                  </td>

                  <td :data-label="translate('tariffication.service')">
                    <span>{{device.service_id }}</span>
                  </td>

                  <td :data-label="translate('device.device_fid')">
                    <router-link :to="'/device/' + device.fid">
                      {{device.fid}}
                    </router-link>
                  </td>

                  <td :data-label="translate('device.name')">
                    <span>{{device.device_name }}</span>
                  </td>

                  <td :data-label="translate('device.comment')">
                    <span>{{ device.comment }}</span>
                  </td>

                  <td :data-label="translate('device.date_start')">
                    <span>{{ device.date_start }}</span>
                  </td>
              </tr>
            </router-link>
          </tbody>
        </table>

        <div v-else style="height: 100%">
          <h3 style="text-align: center" >
            {{translate('no_data')}}
          </h3>
        </div>
      </div>
    </div>

    <div class="tariff_info__right">
      <Summary type="tariff" :info="tariff_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import SisIconStatus from "components/UIComponents/Icon/SisIconStatus.vue";

const fields_to_check = [
  "name",
  "auto_block",
  "billing_type",
  "rate_day",
  "date_start",
  "date_end",
  "descr",
  "active",
  "cost",
  "autoblock_untariffied_devices"
];

export default {
  name: 'TariffInfo',
  components: {
    WrapDatePicker,
    SisIconStatus,
    Summary
  },

  props: {
    tariffs: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tariff_info: {},
      filter_asc: "asc",
      filter_type: "",
    }
  },

  created() {
    this.tariff_info = {
      ...JSON.parse(JSON.stringify(this.tariffs)),
      autoblock_untariffied_devices: this.tariffs.autoblock_untariffied_devices === null ? -1 : this.tariffs.autoblock_untariffied_devices
    }
  },

  activated() {
    this.tariff_info = {
      ...JSON.parse(JSON.stringify(this.tariffs)),
      autoblock_untariffied_devices: this.tariffs.autoblock_untariffied_devices === null ? -1 : this.tariffs.autoblock_untariffied_devices
    }
  },

  computed: {
    autoblock_untariffied_devices_list(){
      return [
        { id: -1, label: "Наследуется от клиента" },
        { id: 0, label: "Не блокируется" },
        { id: 1, label: "Блокируется" },
      ];
    },
    device_list(){
      let device_list = [...this.tariff_info.active_devices];
      return device_list.sort(this.compareNumbers);
    },
    rate_day_list() {
      return [
        { id: 1, label: "с первого дня после отчетного периода" },
        { id: -1, label: "с последнего дня отчетного периода" },
      ];
    },
    billing_type_list() {
      return [
        { id: 1, label: this.translate("tariffication.full_calc") },
        { id: 2, label: this.translate("tariffication.prop_calc") },
        { id: 3, label: this.translate("tariffication.prop_calc_full") },
      ];
    },
    simcard_counts() {
      let list = []
      for (let i = 0; i <= 8; i++) {
        list.push({ id: i, label: i })
      }
      return list;
    },

    has_changes() {
      let tariffs = fields_to_check.reduce((obj, key) => {
        obj[key] = this.tariffs[key];
        return obj;
      }, {});

      let tariff_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.tariff_info[key];
        return obj;
      }, {});

      return JSON.stringify(tariffs) !== JSON.stringify(tariff_info);
    }
  },

  watch: {
    tariffs(){
      this.tariff_info = {
        ...JSON.parse(JSON.stringify(this.tariffs)),
        autoblock_untariffied_devices: this.tariffs.autoblock_untariffied_devices === null ? -1 : this.tariffs.autoblock_untariffied_devices
      }
    }
  },

  methods: {
    copy_fid(){
      let string = ""
      let devices = [...this.tariff_info.active_devices]
      devices.sort((a, b) => a.fid > b.fid ? 1 : -1).forEach(device => {
        string += `${device.fid}\n`
      })
      this.copy_to_clipboard(string)
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    edit_tariff() {
      let tariff_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.tariff_info[key];
        return obj;
      }, {});

      tariff_info.autoblock_untariffied_devices = tariff_info.autoblock_untariffied_devices === -1 ? null : tariff_info.autoblock_untariffied_devices

      this.$http.v1.updateTariffInfo(this.tariff_info.id, tariff_info,(response) => {
        this.global_notify("info", this.translate("tariffication.tariff_updated"));
        this.$emit("update", response.data);
      });
    }
  }
}

</script>

<style lang='scss' scoped>
.tariff_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    margin-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    &__wrap {
      padding: 0 10px;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .content{
      .filter{
        min-width: auto;
      }
      .wrap_datepicker{
        margin-bottom: 10px;
      }
      .vue-treeselect{
        margin-bottom: 10px;
      }
    }

    .main_info{
      .form-group{
        position: relative;
      }
      span.edit{
        position: absolute;
        right: 23px;
        bottom: 28px;
        font-size: 16px;
        cursor: pointer;
        &:hover{
          color: #41b883;
        }
      }
    }

    .response_table {
      height: auto;
      padding: 10px 0 0;
      .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        .links{
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 5px;
          .btn{
            padding: 0;
            font-size: 10px;
          }
        }
      }
      .tariffed_device{
        color: #66615b;
        tr{
          &:hover{
            background-color: #eaeaea;
          }
        }
      }
    }

    .buttons {
      margin-top: 10px;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
